module.exports = __webpack_public_path__ + "static/media/subject.03352892.svg";